import React, { Component } from 'react'
import { IFilterItemProps } from "./models/filter-item.props";
import { OperatorList } from "./models/post.filter.model";
import { FilterItemInputRenderType } from "./models";
import { GetDaysNumber } from '../helpers';

interface IState {
    id: string,
    op: string,
    value: string

}

export class FilterItemDays extends Component<IFilterItemProps, IState> {

    constructor(props) {
        super(props);
    }


    oprators = OperatorList.days;
    inputRenderType: any = FilterItemInputRenderType.SingleBox;

    selectedOptionValue = this.oprators[0].operator;
    selectedValue = '';
    inputValue2 = '';
    inputValue1 = '';

    handleDropDownChange = (event: any) => {
        let selectedObject = this.oprators.find(x => x.name == event.target.value);
        this.selectedOptionValue = selectedObject != null ? selectedObject.operator : "";
        this.inputRenderType = selectedObject?.renderType;
        if (this.selectedOptionValue == 'is' || this.selectedOptionValue == 'isnot') {
            this.selectedValue = 'null';
        }
        if (this.selectedOptionValue === 'eq') {            
            this.selectedValue = GetDaysNumber(selectedObject?.name);

        }
        this.brodCastValue();
    }

    brodCastValue = () => {
        this.setState({ id: this.props.column.columnName, op: this.selectedOptionValue, value: this.selectedValue });
        if (this.inputRenderType == FilterItemInputRenderType.NoBox) {
            this.props.onValueChange({ column: this.props.column.columnName, op: this.selectedOptionValue, value: this.selectedValue });
        }
        else {
            if (this.selectedOptionValue != '') {
                if (this.selectedValue != '') {
                    this.props.onValueChange({ column: this.props.column.columnName, op: this.selectedOptionValue, value: this.selectedValue });
                } else {
                    this.props.clearFilter(this.props.column.columnName);
                }

            }
        }
    }




    render() {
        return (
            <div className="form-group mb-3">
                <label>{this.props.column.displayText}</label>
                <div className="row">
                    <div className={(this.inputRenderType === FilterItemInputRenderType.RangeBox ? 'col-12' : 'col-5')}>
                        <select className="form-control form-control-sm mb-1" name={this.props.column.columnName} onChange={this.handleDropDownChange}>
                            {this.oprators.map((num, index) => {
                                return (
                                    <option key={index} value={num.name} className='form-control'>{num.name}</option>
                                );
                            })}

                        </select>
                    </div>
                </div>
            </div>
        )
    }

}